// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
 
 
 
 
 
import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';

import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';
import AddFareMedia from './addFareMedia';
import EditFareMedia from './updateFareMedia';
import ViewFareMedia from './view-fareMedia';
import FareMediaTable from './fareMediaTable';

const FareMedia: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasFareMediaAddAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'FareMedia')
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasFareMediaAddAccess ? <AddFareMedia /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
        {hasFareMediaAddAccess ? <EditFareMedia/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id`}>
         <ViewFareMedia/>
        </Route>

        <Route exact path={`${baseURL}`}>
          <FareMediaTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { FareMedia };
